import React, { useState } from "react";
import { Alert, Button, Form, Input } from "antd";
import { FaCheck } from "react-icons/fa";
import MemberServiceInstance from "../../services/MemberService";
import { getLowerCaseString } from "../../helpers/StringFormatHelper";
import { isValidValue, setFormFieldValue } from "../../helpers/FormHelper";
import { getErrorMessage } from "../../helpers/ApiResponseHelper";
import { setAuth } from "../../store/slices/AuthSlice";
import { setMemberData } from "../../store/slices/MemberSlice";
import { useDispatch } from "react-redux";

export default function ModalLogin({ isLogin, handleLogin, handleRegister, handleForgotPass }) {
	const [submitLoading, setSubmitLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState(null);
	const hasError = isValidValue(errorMessage);
	const [form] = Form.useForm();
	const dispatch = useDispatch();

	const formatRequestData = (data) => {
		return {
			username: getLowerCaseString(data.username),
			password: setFormFieldValue(data.password),
		};
	};

	const onLogin = async () => {
		try {
			setSubmitLoading(true);
			const data = await form.validateFields();
			const requestData = formatRequestData(data);
			const response = await MemberServiceInstance.login(requestData);
			const responseData = response?.data;
			const { success, message, result } = responseData;
			if (success === true) {
				const { accessToken, member } = result;
				dispatch(setAuth(accessToken));
				dispatch(setMemberData(member));
				form.resetFields();
				handleLogin();
			} else {
				const errorMsg = isValidValue(message) ? message : 'Registration failed. Please try again.';
				setErrorMessage(errorMsg);
			}
		} catch (error) {
			if (error?.values) {
				setSubmitLoading(false);
				return;
			}

			const errorMessage = getErrorMessage(error?.response, error?.message);
			setErrorMessage(errorMessage);
		} finally {
			setSubmitLoading(false);
		}
	};

	return (
		<>
			<div
				className={`modal fade modal-login ${isLogin ? "show d-block" : ""}`}
				id="exampleModalToggle"
				aria-hidden="true"
				aria-label="exampleModalToggleLabel"
				tabIndex={-1}
			>
				<div className="modal-dialog modal-dialog-centered">
					<div className="modal-content">
						<button type="button" className="btn-close" onClick={handleLogin} aria-label="Close" />

						<div className="tfre_registration-form register-modal">
							<h2>Login:</h2>

							<Form
								form={form}
								layout="vertical"
								className="tfre_login"
								id="tfre_custom-login-form"
								onFinish={onLogin}
							>
								<div className="container">
									{hasError === true && (
										<div className="row">
											<div className="col-12">
												<Alert
													type="error"
													message={errorMessage}
													showIcon
													closable
													onClose={() => setErrorMessage(null)}
													style={{ marginBottom: 12 }}
												/>
											</div>
										</div>
									)}

									<div className="row">
										<div className="col-12">
											<Form.Item
												name="username"
												label="Email:"
												className="form-group"
												rules={[{ required: true, message: "Please input your email!" }]}
											>
												<Input
													size="large"
													id="username"
													placeholder="Email"
													autoComplete="username"
												/>
											</Form.Item>
										</div>
									</div>

									<div className="row">
										<div className="col-12">
											<Form.Item
												name="password"
												label="Password:"
												className="form-group"
												rules={[{ required: true, message: "Please input your password!" }]}
											>
												<Input.Password
													size="large"
													id="password"
													placeholder="Your password"
													autoComplete="current-password"
												/>
											</Form.Item>
										</div>
									</div>

									<div className="row" style={{ marginTop: -6, marginBottom: 10 }}>
										<div className="col-12">
											<a
												onClick={() => { handleLogin(); handleForgotPass(); }}
												className="tfre-reset-password"
												style={{ cursor: "pointer" }}
											>
												Forgot password?
											</a>
										</div>
									</div>

									<div className="row">
										<div className="col-12">
											<Button
												htmlType="submit"
												block
												loading={submitLoading}
												style={{ minHeight: 50 }}
												className="flat-button"
												icon={<FaCheck style={{ marginRight: 10 }} />}
											>
												{!submitLoading && "Login"}
											</Button>
										</div>
									</div>
								</div>
							</Form>
						</div>

						<div className="container text-center cursor-pointer" id="tfre_register_redirect">
							<p>
								Don&apos;t you have an account?{" "}
								<a
									className="tfre_register"
									style={{ cursor: "pointer" }}
									onClick={() => { handleLogin(); handleRegister(); }}
								>
									Register.
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>

			{isLogin && <div className="modal-backdrop fade show" onClick={handleLogin} />}
		</>
	);
}
